module.exports = __webpack_public_path__ + "static/media/GT04_GT_Room-Types.a4dbfa54.csv";